module.exports = __webpack_public_path__ + "static/media/icon-list.288e3b55.svg";